import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-foreground-950 text-white">
      <div className="px-4 md:px-8 py-14 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-2/5">
            <Link
              to="/"
              className="font-heading text-3xl md:text-4xl font-bold tracking-wide whitespace-nowrap"
            >
              hipobuy.yachts
            </Link>
            <p className="mt-4 text-white/60 text-sm leading-relaxed max-w-sm">
              {t("footer.description")}
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full border border-white/20 text-white/80 hover:bg-white/10 transition-colors" aria-label="Twitter">
                <i className="ri-twitter-x-line"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full border border-white/20 text-white/80 hover:bg-white/10 transition-colors" aria-label="LinkedIn">
                <i className="ri-linkedin-line"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full border border-white/20 text-white/80 hover:bg-white/10 transition-colors" aria-label="Instagram">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full border border-white/20 text-white/80 hover:bg-white/10 transition-colors" aria-label="Facebook">
                <i className="ri-facebook-line"></i>
              </a>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-10 lg:gap-20">
            <div>
              <h4 className="text-xs font-semibold uppercase tracking-widest text-white/50 mb-3">{t("footer.address")}</h4>
              <p className="text-sm text-white/70 leading-relaxed">
                {t("footer.address.line1")}<br />
                {t("footer.address.line2")}
              </p>
            </div>
            <div>
              <h4 className="text-xs font-semibold uppercase tracking-widest text-white/50 mb-3">{t("footer.phone")}</h4>
              <p className="text-sm text-white/70">{t("footer.phone.value")}</p>
            </div>
            <div>
              <h4 className="text-xs font-semibold uppercase tracking-widest text-white/50 mb-3">{t("footer.email")}</h4>
              <p className="text-sm text-white/70">{t("footer.email.value")}</p>
            </div>
          </div>

          <div className="lg:w-48 flex-shrink-0">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20lifestyle%20still%20life%20with%20designer%20watch%20silk%20scarf%20and%20fresh%20flowers%20on%20marble%20surface%2C%20luxury%20editorial%20photography%2C%20soft%20natural%20light%2C%20refined%20European%20aesthetic&width=400&height=560&seq=footer-v2-fashion&orientation=portrait"
              alt="Hipobuy fashion lifestyle"
              title="Hipobuy Spreadsheet - Lifestyle Mode"
              className="w-full h-56 object-cover rounded-lg"
            />
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-white/40 text-xs">{t("footer.copyright")}</p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-white/40 text-xs hover:text-white/70 transition-colors whitespace-nowrap">{t("footer.security")}</a>
            <a href="#" className="text-white/40 text-xs hover:text-white/70 transition-colors whitespace-nowrap">{t("footer.faq")}</a>
            <a href="#" className="text-white/40 text-xs hover:text-white/70 transition-colors whitespace-nowrap">{t("footer.contact")}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}